
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/filter_toggle/templates/new_filters_tooltip"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='newFiltersTooltip-content'>\n  Filtering is now a keyword search away! Learn more about the latest filter features\n  <a href='https://help.workwithopal.com/hc/en-us/articles/228552287-Filter-Search-and-Sort' target='_blank' title='Filters Search and Sort'>here.</a>\n</div>\n<div class='newFiltersTooltip-footer'>\n  <div class='newFiltersTooltip-acceptButtonRegion'></div>\n</div>\n";
},"useData":true});
    }).call(this);
  